import { useEffect } from 'react';
import { sendComscoreBeacon } from '@/libs/comscore';

export const useComscoreScrollTracking = (pageData) => {
  useEffect(() => {
    let sent50 = false;
    let sent90 = false;

    const handleScroll = () => {
      const scrollPercent = ((window.scrollY + window.innerHeight) / document.documentElement.scrollHeight) * 100;

      if (scrollPercent >= 50 && !sent50) {
        sent50 = true;
        sendComscoreBeacon({
          name: pageData?.pageType,
          c3: pageData?.siteSection,
          c5: '50',
        });
      }

      if (scrollPercent >= 90 && !sent90) {
        sent90 = true;
        sendComscoreBeacon({
          name: pageData?.pageType,
          c3: pageData?.siteSection,
          c5: '90',
        });
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [pageData]);
};
